import type { Challenge } from '@geosport/shared';

const KEY = 'geosport:challenge';

/** Remembers the score a friend challenged this visitor to beat, for the results screen. */
export function rememberChallenge(c: Challenge): void {
  try {
    window.sessionStorage.setItem(KEY, JSON.stringify(c));
  } catch {
    /* private mode: the banner still shows, the comparison just won't */
  }
}

export function readChallenge(): Challenge | null {
  try {
    const raw = window.sessionStorage.getItem(KEY);
    if (!raw) return null;
    const v: unknown = JSON.parse(raw);
    if (
      typeof v === 'object' &&
      v !== null &&
      typeof (v as Challenge).puzzleNo === 'number' &&
      typeof (v as Challenge).score === 'number'
    ) {
      return v as Challenge;
    }
  } catch {
    /* ignore */
  }
  return null;
}
